import { colors } from '../../colors';
var para = {
  messageColor: colors.deepOrange
};
export default para;